// @ts-strict-ignore
export class SDP {
    public media: any;
    public session: string;
    public raw: string;
    public logger: any = console;

    public constructor(sdp: string) {
        this.media = sdp.split('\r\nm=');
        for (let i = 1; i < this.media.length; i++) {
            this.media[i] = 'm=' + this.media[i];
            if (i != this.media.length - 1) {
                this.media[i] += '\r\n';
            }
        }
        this.session = this.media.shift() + '\r\n';
        this.raw = this.session + this.media.join('');
    }

    // remove iSAC and CN from SDP
    public mangle() {
        let i; let j; let mline; let lines; let rtpmap; let newdesc;
        for (i = 0; i < this.media.length; i++) {
            lines = this.media[i].split('\r\n');
            lines.pop(); // remove empty last element
            mline = SDPUtil.parse_mline(lines.shift());
            if (mline.media != 'audio')
                continue;
            newdesc = '';
            mline.fmt.length = 0;
            for (j = 0; j < lines.length; j++) {
                if (lines[j].substr(0, 9) == 'a=rtpmap:') {
                    rtpmap = SDPUtil.parse_rtpmap(lines[j]);
                    if (rtpmap.name == 'CN' || rtpmap.name == 'ISAC')
                        continue;
                    mline.fmt.push(rtpmap.id);
                    newdesc += lines[j] + '\r\n';
                } else {
                    newdesc += lines[j] + '\r\n';
                }
            }
            this.media[i] = SDPUtil.build_mline(mline) + '\r\n';
            this.media[i] += newdesc;
        }
        this.raw = this.session + this.media.join('');
    }

    // remove lines matching prefix from session section
    public removeSessionLines(prefix) {
        const self = this;
        const lines = SDPUtil.find_lines(this.session, prefix);
        lines.forEach(function(line) {
            self.session = self.session.replace(line + '\r\n', '');
        });
        this.raw = this.session + this.media.join('');
        return lines;
    }

    // remove lines matching prefix from a media section specified by mediaindex
    // TODO: non-numeric mediaindex could match mid
    public removeMediaLines(mediaindex, prefix) {
        const self = this;
        const lines = SDPUtil.find_lines(this.media[mediaindex], prefix);
        lines.forEach(function(line) {
            self.media[mediaindex] = self.media[mediaindex].replace(line + '\r\n', '');
        });
        this.raw = this.session + this.media.join('');
        return lines;
    }

    // add content's to a jingle element
    public toJingle(elem, thecreator, confId, bandwidthLimit) {
        let i; let j; let k; let mline; let ssrc; let rtpmap; let tmp; let line; let lines; let simulcast;
        let indexMline = 0;
        const self = this;
        // new bundle plan
        if (SDPUtil.find_line(this.session, 'a=group:')) {
            lines = SDPUtil.find_lines(this.session, 'a=group:');
            for (i = 0; i < lines.length; i++) {
                tmp = lines[i].split(' ');
                const semantics = tmp.shift().substr(8);
                elem.c('group', { xmlns: 'urn:xmpp:jingle:apps:grouping:0', semantics: semantics });
                for (j = 0; j < tmp.length; j++) {
                    elem.c('content', { name: tmp[j] }).up();
                }
                elem.up();
            }
        }
        // old bundle plan, to be removed
        let bundle = [];
        if (SDPUtil.find_line(this.session, 'a=group:BUNDLE')) {
            bundle = SDPUtil.find_line(this.session, 'a=group:BUNDLE ').split(' ');
            bundle.shift();
        }
        for (i = 0; i < this.media.length; i++) {
            mline = SDPUtil.parse_mline(this.media[i].split('\r\n')[0]);
            if (!(mline.media == 'audio' || mline.media == 'video' || mline.media === 'application')) {
                continue;
            }
            if (SDPUtil.find_line(this.media[i], 'a=ssrc:')) {
                ssrc = SDPUtil.find_line(this.media[i], 'a=ssrc:').substring(7).split(' ')[0]; // take the first
            } else {
                ssrc = false;
            }

            //Simulcast: Check presence of attribute 'simulcast'
            if (SDPUtil.find_line(this.media[i], 'a=simulcast:')) {
                simulcast = SDPUtil.find_line(this.media[i], 'a=simulcast:').substring(12).trim();
            } else {
                simulcast = false;
            }

            elem.c('content', { creator: thecreator, name: mline.media });
            if (SDPUtil.find_line(this.media[i], 'a=mid:')) {
                // prefer identifier from a=mid if present
                const mid = SDPUtil.parse_mid(SDPUtil.find_line(this.media[i], 'a=mid:'));
                elem.attrs({ name: mid });
            }
            if (SDPUtil.find_line(this.media[i], 'a=rtpmap:').length) {
                elem.c('description',
                    {
                        xmlns: 'urn:xmpp:jingle:apps:rtp:1',
                        media: mline.media
                    });
                if (ssrc) {
                    elem.attrs({ ssrc: ssrc });
                }

                if ((!confId || confId === -1) && mline.media === "video") {
                    const value = (indexMline === 0) ? bandwidthLimit.video : bandwidthLimit.sharing;
                    indexMline += 1;
                    elem.c("bandwidth", { type: 'AS' }).t(value);
                    elem.up();
                }

                for (j = 0; j < mline.fmt.length; j++) {
                    //add white space at the end of searching line to avoid finding substring of some part
                    //for instance we find the line when searchinf for this RTPMAP:9
                    // 'a=rtpmap:96 opus/48000/2'
                    // 'a=rtpmap:9'
                    rtpmap = SDPUtil.find_line(this.media[i], 'a=rtpmap:' + mline.fmt[j] + ' ');
                    if (rtpmap) {
                        elem.c('payload-type', SDPUtil.parse_rtpmap(rtpmap));
                        // put any 'a=fmtp:' + mline.fmt[j] lines into <param name=foo value=bar/>
                        if (SDPUtil.find_line(this.media[i], 'a=fmtp:' + mline.fmt[j] + ' ')) {
                            tmp = SDPUtil.parse_fmtp(SDPUtil.find_line(this.media[i], 'a=fmtp:' + mline.fmt[j] + ' '));
                            for (k = 0; k < tmp.length; k++) {
                                elem.c('parameter', tmp[k]).up();
                            }
                        }
                        this.RtcpFbToJingle(i, elem, mline.fmt[j]); // XEP-0293 -- map a=rtcp-fb

                        elem.up();
                    }
                }
                if (SDPUtil.find_line(this.media[i], 'a=crypto:', this.session)) {
                    elem.c('encryption', { required: 1 });
                    const crypto = SDPUtil.find_lines(this.media[i], 'a=crypto:', this.session);
                    crypto.forEach(function(line) {
                        elem.c('crypto', SDPUtil.parse_crypto(line)).up();
                    });
                    elem.up(); // end of encryption
                }

                if (ssrc) {
                    // new style mapping
                    elem.c('source', { ssrc: ssrc, xmlns: 'urn:xmpp:jingle:apps:rtp:ssma:0' });
                    // FIXME: group by ssrc and support multiple different ssrcs
                    const ssrclines = SDPUtil.find_lines(this.media[i], 'a=ssrc:');
                    ssrclines.forEach(function(line) {
                        const idx = line.indexOf(' ');
                        const linessrc = line.substr(0, idx).substr(7);
                        if (linessrc != ssrc) {
                            elem.up();
                            ssrc = linessrc;
                            elem.c('source', { ssrc: ssrc, xmlns: 'urn:xmpp:jingle:apps:rtp:ssma:0' });
                        }
                        const kv = line.substr(idx + 1);
                        elem.c('parameter');
                        if (kv.indexOf(':') == -1) {
                            elem.attrs({ name: kv });
                        } else {
                            elem.attrs({ name: kv.split(':', 2)[0] });
                            elem.attrs({ value: kv.split(':', 2)[1] });
                        }
                        elem.up();
                    });
                    elem.up();
                }

                //Add simulcast information (rid)
                //Example of the conversion
                // SDP semantics:
                // a=simulcast: send rid=h;m;l
                // a=rid:h send
                // a=rid:m send
                // a=rid:l send
                //
                // Jingle semantics
                // <simulcast rids=" send rid=h;m;l" xmlns="urn:xmpp:jingle:apps:rtp:ssma:0">
                // 		<rid name="h" xmlns="urn:xmpp:jingle:apps:rtp:sim:0"/>
                // 		<rid name="m" xmlns="urn:xmpp:jingle:apps:rtp:sim:0"/>
                // 		<rid name="l" xmlns="urn:xmpp:jingle:apps:rtp:sim:0"/>
                // 	</simulcast>

                if (simulcast) {
                    //idx = simulcast.indexOf('rid=');
                    //elem.c('simulcast', { rids: simulcast.substr(idx+4), xmlns: 'urn:xmpp:jingle:apps:rtp:sim:0' });
                    elem.c('simulcast', { rids: simulcast, xmlns: 'urn:xmpp:jingle:apps:rtp:sim:0' });
                    const rids = SDPUtil.find_lines(this.media[i], 'a=rid:');
                    rids.forEach(function(line) {
                        const idx = line.indexOf(' ');
                        const ridName = line.substr(0, idx).substr(6);
                        elem.c('rid',
                            {
                                xmlns: 'urn:xmpp:jingle:apps:rtp:rid:0',
                                name: ridName
                            });
                        elem.up();
                    });
                    elem.up();
                }

                const ssrcgrouplines = SDPUtil.find_lines(this.media[i], 'a=ssrc-group');
                ssrcgrouplines.forEach(function(line) {
                    let idx = line.indexOf(' ');
                    const semantics = line.substr(0, idx).substr(13);
                    elem.c('ssrc-group', { xmlns: 'urn:xmpp:jingle:apps:rtp:ssma:0', semantics: semantics });
                    let kv = line.substr(idx + 1);
                    while (kv.length > 0) {
                        var ssrc_gr;
                        idx = kv.indexOf(' ');
                        if (idx > 0) {
                            ssrc_gr = kv.substr(0, idx);
                            kv = kv.substr(idx + 1);
                        } else {
                            ssrc_gr = kv.substr(0, kv.length);
                            kv = '';
                        }
                        elem.c('source', { ssrc: ssrc_gr }).up();
                    }
                    elem.up();
                });

                if (SDPUtil.find_line(this.media[i], 'a=rtcp-mux')) {
                    elem.c('rtcp-mux').up();
                }

                // XEP-0293 -- map a=rtcp-fb:*
                this.RtcpFbToJingle(i, elem, '*');

                // XEP-0294
                if (SDPUtil.find_line(this.media[i], 'a=extmap:')) {
                    lines = SDPUtil.find_lines(this.media[i], 'a=extmap:');
                    for (j = 0; j < lines.length; j++) {
                        tmp = SDPUtil.parse_extmap(lines[j]);
                        elem.c('rtp-hdrext', {
                            xmlns: 'urn:xmpp:jingle:apps:rtp:rtp-hdrext:0',
                            uri: tmp.uri,
                            id: tmp.value
                        });
                        if (tmp.hasOwnProperty('direction')) {
                            switch (tmp.direction) {
                                case 'sendonly':
                                    elem.attrs({ senders: 'responder' });
                                    break;
                                case 'recvonly':
                                    elem.attrs({ senders: 'initiator' });
                                    break;
                                case 'sendrecv':
                                    elem.attrs({ senders: 'both' });
                                    break;
                                case 'inactive':
                                    elem.attrs({ senders: 'none' });
                                    break;
                                default:
                                    break;
                            }
                        }
                        // TODO: handle params
                        elem.up();
                    }
                }
                elem.up(); // end of description
            }

            // map ice-ufrag/pwd, dtls fingerprint, candidates
            this.transportToJingle(i, elem);

            if (SDPUtil.find_line(this.media[i], 'a=sendrecv', this.session)) {
                elem.attrs({ senders: 'both' });
            } else if (SDPUtil.find_line(this.media[i], 'a=sendonly', this.session)) {
                elem.attrs({ senders: 'initiator' });
            } else if (SDPUtil.find_line(this.media[i], 'a=recvonly', this.session)) {
                elem.attrs({ senders: 'responder' });
            } else if (SDPUtil.find_line(this.media[i], 'a=inactive', this.session)) {
                elem.attrs({ senders: 'none' });
            }
            if (mline.port == '0' && !SDPUtil.find_line(this.media[i], 'a=bundle-only', this.session)) {
                // estos hack to reject an m-line
                elem.attrs({ senders: 'rejected' });
            }
            elem.up(); // end of content
        }

        if (confId && confId !== -1) {
            elem.c('conference', {
                xmlns: 'urn:xmpp:janus:1',
                id: confId
            });
            elem.up();
        }

        elem.up();
        return elem;
    }

    public transportToJingle(mediaindex, elem) {
        const i = mediaindex;
        let tmp;
        const self = this;
        elem.c('transport');

        // XEP-0343 DTLS/SCTP
        const media = this.media[mediaindex];
        const mediaLine = SDPUtil.parse_mline(this.media[i].split('\r\n')[0]);
        if (mediaLine.media === 'application' && mediaLine.fmt[0] === 'webrtc-datachannel') {
            // Get the SCTP port
            let port: string;
            const sctpPortLine = SDPUtil.find_line(media, 'a=sctp-port:', this.session);
            if (sctpPortLine) port = sctpPortLine.substring(12);

            // Get the Data Channel max message size
            let maxSize: string;
            const maxSizeLine = SDPUtil.find_line(media, 'a=max-message-size:', this.session);
            if (maxSizeLine) maxSize = maxSizeLine.substring(19);

            elem.c('sctpmap', {
                xmlns: 'urn:xmpp:jingle:transports:dtls-sctp:1',
                number: port,
                protocol: 'webrtc-datachannel'
            });
            if (maxSize.length > 2) elem.attrs({ maxMessageSize: maxSize});
            elem.up();
        }


        // XEP-0320
        const fingerprints = SDPUtil.find_lines(this.media[mediaindex], 'a=fingerprint:', this.session);
        fingerprints.forEach(function(line) {
            tmp = SDPUtil.parse_fingerprint(line);
            // tmp.xmlns = 'urn:xmpp:tmp:jingle:apps:dtls:0';
            tmp.xmlns = 'urn:xmpp:jingle:apps:dtls:0'; // -- FIXME: update receivers first
            elem.c('fingerprint').t(tmp.fingerprint);
            delete tmp.fingerprint;
            line = SDPUtil.find_line(self.media[mediaindex], 'a=setup:', self.session);
            if (line) {
                tmp.setup = line.substr(8);
            }
            elem.attrs(tmp);
            elem.up(); // end of fingerprint
        });
        tmp = SDPUtil.iceparams(this.media[mediaindex], this.session);
        if (tmp) {
            tmp.xmlns = 'urn:xmpp:jingle:transports:ice-udp:1';
            elem.attrs(tmp);
            // XEP-0176
            if (SDPUtil.find_line(this.media[mediaindex], 'a=candidate:', this.session)) { // add any a=candidate lines
                const lines = SDPUtil.find_lines(this.media[mediaindex], 'a=candidate:', this.session);
                lines.forEach(function(line) {
                    elem.c('candidate', SDPUtil.candidateToJingle(line, self.logger)).up();
                });
            }
        }
        elem.up(); // end of transport
    }

    public RtcpFbToJingle(mediaindex, elem, payloadtype) { // XEP-0293
        const lines = SDPUtil.find_lines(this.media[mediaindex], 'a=rtcp-fb:' + payloadtype);
        lines.forEach(function(line) {
            const tmp = SDPUtil.parse_rtcpfb(line);
            if (tmp.type == 'trr-int') {
                elem.c('rtcp-fb-trr-int', { xmlns: 'urn:xmpp:jingle:apps:rtp:rtcp-fb:0', value: tmp.params[0] });
                elem.up();
            } else {
                elem.c('rtcp-fb', { xmlns: 'urn:xmpp:jingle:apps:rtp:rtcp-fb:0', type: tmp.type });
                if (tmp.params.length > 0) {
                    elem.attrs({ 'subtype': tmp.params[0] });
                }
                elem.up();
            }
        });
    }

    public RtcpFbFromJingle(elem, payloadtype) { // XEP-0293
        let media = '';
        let tmp = elem.find('>rtcp-fb-trr-int[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]');
        if (tmp.length) {
            media += 'a=rtcp-fb:' + '*' + ' ' + 'trr-int' + ' ';
            if (tmp.attr('value')) {
                media += tmp.attr('value');
            } else {
                media += '0';
            }
            media += '\r\n';
        }
        tmp = elem.find('>rtcp-fb[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]');
        tmp.each(function() {
            media += 'a=rtcp-fb:' + payloadtype + ' ' + $(this).attr('type');
            if ($(this).attr('subtype')) {
                media += ' ' + $(this).attr('subtype');
            }
            media += '\r\n';
        });
        return media;
    }

    // construct an SDP from a jingle stanza
    public fromJingle(jingle, session) {
        const self = this;
        //manage session ID and number of SDP renego
        if (!session.timestamp) session.timestamp = Date.now();

        this.raw = 'v=0\r\n' +
            'o=- ' + session.timestamp + ' ' + session.remoteSDPNumber + ' IN IP4 0.0.0.0\r\n' +
            's=-\r\n' +
            't=0 0\r\n';
        // http://tools.ietf.org/html/draft-ietf-mmusic-sdp-bundle-negotiation-04#section-8
        if ($(jingle).find('>group[xmlns="urn:xmpp:jingle:apps:grouping:0"]').length) {
            $(jingle).find('>group[xmlns="urn:xmpp:jingle:apps:grouping:0"]').each(function(idx, group) {
                const contents = $(group).find('>content').map(function(idx, content) {
                    return content.getAttribute('name');
                }).get();
                if (contents.length > 0) {
                    self.raw += 'a=group:' + (group.getAttribute('semantics') || group.getAttribute('type')) + ' ' + contents.join(' ') + '\r\n';
                }
            });
        } else if ($(jingle).find('>group[xmlns="urn:ietf:rfc:5888"]').length) {
            // temporary namespace, not to be used. to be removed soon.
            $(jingle).find('>group[xmlns="urn:ietf:rfc:5888"]').each(function(idx, group) {
                const contents = $(group).find('>content').map(function(idx, content) {
                    return content.getAttribute('name');
                }).get();
                if (group.getAttribute('type') !== null && contents.length > 0) {
                    self.raw += 'a=group:' + group.getAttribute('type') + ' ' + contents.join(' ') + '\r\n';
                }
            });
        } else {
            // for backward compability, to be removed soon
            // assume all contents are in the same bundle group, can be improved upon later
            const bundle = $(jingle).find('>content').filter(function(idx, content) {
                return $(content).find('>bundle').length > 0;
            }).map(function(idx, content) {
                return content.getAttribute('name');
            }).get();
            if (bundle.length) {
                this.raw += 'a=group:BUNDLE ' + bundle.join(' ') + '\r\n';
            }
        }

        this.raw += 'a=ice-options:trickle' + '\r\n';

        this.session = this.raw;
        jingle.find('>content').each(function() {
            const media = self.jingle2media($(this));
            self.media.push(media);
        });

        // reconstruct msid-semantic -- apparently not necessary
        const msid: any = SDPUtil.parse_ssrc(this.raw);
        if (msid.hasOwnProperty('mslabel') && msid.mslabel) {
            this.session += "a=msid-semantic: WMS " + msid.mslabel + "\r\n";
        }

        this.raw = this.session + this.media.join('');

        session.remoteSDPNumber += 1;
    }

    // translate a jingle content element into an an SDP media part
    public jingle2media(content: any): string {
        let media = '';
        const desc = content.find('description');
        const self = this;

        let tmp: any = { media: desc.attr('media') };

        // Handle port
        tmp.port = '1';
        if (content.attr('senders') === 'rejected') tmp.port = '0'; // Hack to reject an m-line.

        // Handle protocol
        tmp.proto = (content.find('>transport>fingerprint').length || desc.find('encryption').length) ? 'RTP/SAVPF' : 'RTP/AVPF';

        // Handle fmt(s)
        tmp.fmt = desc.find('payload-type').map(function() { return this.getAttribute('id'); }).get();

        // Handle specific SCTP Data Channel case
        const sctpmap = content.find('>transport[xmlns="urn:xmpp:jingle:transports:ice-udp:1"]>sctpmap[xmlns="urn:xmpp:jingle:transports:dtls-sctp:1"]');
        if (sctpmap.length) {
            tmp.media = 'application';
            tmp.proto = 'UDP/DTLS/SCTP';
            tmp.fmt = [sctpmap.attr('protocol')];
        }

        media += SDPUtil.build_mline(tmp) + '\r\n';
        media += 'c=IN IP4 0.0.0.0\r\n';

        // Set bandwidth limit received from jingle
        let bandwidthLimit = desc.find('bandwidth').map(function() { return $(this).text(); });
        if (bandwidthLimit.length) bandwidthLimit = bandwidthLimit[0]; else bandwidthLimit = null;
        if (bandwidthLimit) {
            bandwidthLimit = parseInt(bandwidthLimit, 10);
            let modifier = 'AS';
            if ((window as any).adapter.browserDetails.browser === 'firefox') {
                bandwidthLimit = (bandwidthLimit >>> 0) * 1000;
                modifier = 'TIAS';
            }
            media += `b=${modifier}:${bandwidthLimit}\r\n`;
        }

        media += 'a=rtcp:1 IN IP4 0.0.0.0\r\n';

        // Handle transport node
        tmp = content.find('>transport[xmlns="urn:xmpp:jingle:transports:ice-udp:1"]');
        if (tmp.length) {
            if (tmp.attr('ufrag')) media += SDPUtil.build_iceufrag(tmp.attr('ufrag')) + '\r\n';
            if (tmp.attr('pwd')) media += SDPUtil.build_icepwd(tmp.attr('pwd')) + '\r\n';

            tmp.find('>fingerprint').each(function() {
                media += `a=fingerprint:${this.getAttribute('hash')} ${$(this).text()}\r\n`;
                if (this.getAttribute('setup')) media += `a=setup:${this.getAttribute('setup')}\r\n`;
            });
        }

        // Get simulcast information
        tmp = content.find('description>simulcast[xmlns="urn:xmpp:jingle:apps:rtp:sim:0"]');
        if (tmp.length) {
            const rids = tmp.attr('rids');
            if (rids) {
                media += 'a=simulcast: ' + rids + '\r\n';
            }
            tmp.find('>rid').each(function() {
                media += 'a=rid:' + this.getAttribute('name') + ' recv';
                media += '\r\n';
            });
        }

        // Handle senders
        switch (content.attr('senders')) {
            case 'initiator': media += 'a=sendonly\r\n'; break;
            case 'responder': media += 'a=recvonly\r\n'; break;
            case 'none': media += 'a=inactive\r\n'; break;
            case 'both': media += 'a=sendrecv\r\n'; break;
            default: break;
        }

        media += `a=mid:${content.attr('name')}\r\n`;

        // Handle specific SCTP Data Channel case
        if (sctpmap.length) {
            media += `a=sctp-port:${sctpmap.attr('number')}\r\n`;
            media += `a=max-message-size:${sctpmap.attr('maxMessageSize') || '65535'}\r\n`;
        }

        // <description><rtcp-mux/></description>
        // see http://code.google.com/p/libjingle/issues/detail?id=309 -- no spec though
        // and http://mail.jabber.org/pipermail/jingle/2011-December/001761.html
        if (desc.find('rtcp-mux').length) media += 'a=rtcp-mux\r\n';

        if (desc.find('encryption').length) {
            desc.find('encryption>crypto').each(function() {
                media += 'a=crypto:' + this.getAttribute('tag');
                media += ' ' + this.getAttribute('crypto-suite');
                media += ' ' + this.getAttribute('key-params');
                if (this.getAttribute('session-params')) {
                    media += ' ' + this.getAttribute('session-params');
                }
                media += '\r\n';
            });
        }
        desc.find('payload-type').each(function() {
            media += SDPUtil.build_rtpmap(this) + '\r\n';
            if ($(this).find('>parameter').length) {
                media += 'a=fmtp:' + this.getAttribute('id') + ' ';
                media += $(this).find('parameter').map(function() { return (this.getAttribute('name') ? (this.getAttribute('name') + '=') : '') + this.getAttribute('value'); }).get().join(';');
                media += '\r\n';
            }
            // xep-0293
            media += self.RtcpFbFromJingle($(this), this.getAttribute('id'));
        });

        // xep-0293
        media += self.RtcpFbFromJingle(desc, '*');

        // xep-0294
        tmp = desc.find('>rtp-hdrext[xmlns="urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"]');
        tmp.each(function() {
            media += 'a=extmap:' + this.getAttribute('id') + ' ' + this.getAttribute('uri') + '\r\n';
        });

        content.find('>transport[xmlns="urn:xmpp:jingle:transports:ice-udp:1"]>candidate').each(function() {
            media += SDPUtil.candidateFromJingle(this);
        });

        tmp = content.find('description>source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]');
        tmp.each(function() {
            const ssrc = this.getAttribute('ssrc');
            $(this).find('>parameter').each(function() {
                const name = this.getAttribute('name');
                const value = this.getAttribute('value');
                if (name?.length && value?.length) media += 'a=ssrc:' + ssrc + ' ' + name + ':' + value;
                media += '\r\n';
            });
        });

        tmp = content.find('description>ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]');
        tmp.each(function() {
            const semantics = this.getAttribute('semantics');
            media += 'a=ssrc-group:' + semantics;
            $(this).find('>source').each(function() {
                media += ' ' + this.getAttribute('ssrc');
            });
            media += '\r\n';
        });

        return media;
    }
}

export class SDPUtil {
    public static iceparams(mediadesc, sessiondesc) {
        let data: any = null;
        if (SDPUtil.find_line(mediadesc, 'a=ice-ufrag:', sessiondesc) &&
            SDPUtil.find_line(mediadesc, 'a=ice-pwd:', sessiondesc)) {
            data = {
                ufrag: SDPUtil.parse_iceufrag(SDPUtil.find_line(mediadesc, 'a=ice-ufrag:', sessiondesc)),
                pwd: SDPUtil.parse_icepwd(SDPUtil.find_line(mediadesc, 'a=ice-pwd:', sessiondesc))
            };
        }
        return data;
    }

    public static parse_iceufrag(line) {
        return line.substring(12);
    }

    public static build_iceufrag(frag) {
        return 'a=ice-ufrag:' + frag;
    }

    public static parse_icepwd(line) {
        return line.substring(10);
    }

    public static build_icepwd(pwd) {
        return 'a=ice-pwd:' + pwd;
    }

    public static parse_mid(line) {
        return line.substring(6);
    }

    public static parse_mline(line) {
        const parts = line.substring(2).split(' ');
        const data: any = {};
        data.media = parts.shift();
        data.port = parts.shift();
        data.proto = parts.shift();
        if (parts[parts.length - 1] === '') { // trailing whitespace
            parts.pop();
        }
        data.fmt = parts;
        return data;
    }

    public static build_mline(mline) {
        return 'm=' + mline.media + ' ' + mline.port + ' ' + mline.proto + ' ' + mline.fmt.join(' ');
    }

    public static parse_rtpmap(line) {
        let parts = line.substring(9).split(' ');
        const data: any = {};
        data.id = parts.shift();
        parts = parts[0].split('/');
        data.name = parts.shift();
        data.clockrate = parts.shift();
        data.channels = parts.length ? parts.shift() : '1';
        return data;
    }

    public static build_rtpmap(el) {
        let line = 'a=rtpmap:' + el.getAttribute('id') + ' ' + el.getAttribute('name') + '/' + el.getAttribute('clockrate');
        if (el.getAttribute('channels') && el.getAttribute('channels') != '1') {
            line += '/' + el.getAttribute('channels');
        }
        return line;
    }

    public static parse_simulcast(line) {
        const parts = line.substr(13).split(' '); //a=simulcast:<space> ????
        const data: any = {};
        data.direction = parts.shift();
        data.rid = parts.shift().substr(4);
        return data;
    }

    public static parse_crypto(line) {
        const parts = line.substring(9).split(' ');
        const data: any = {};
        data.tag = parts.shift();
        data['crypto-suite'] = parts.shift();
        data['key-params'] = parts.shift();
        if (parts.length) {
            data['session-params'] = parts.join(' ');
        }
        return data;
    }

    public static parse_fingerprint(line) { // RFC 4572
        const parts = line.substring(14).split(' ');
        const data: any = {};
        data.hash = parts.shift();
        data.fingerprint = parts.shift();
        // TODO assert that fingerprint satisfies 2UHEX *(":" 2UHEX) ?
        return data;
    }

    public static parse_fmtp(line) {
        let parts = line.split(' ');
        let i; let key; let value;
        const data: any = [];
        parts.shift();
        parts = parts.join(' ').split(';');
        for (i = 0; i < parts.length; i++) {
            key = parts[i].split('=')[0];
            while (key.length && key[0] == ' ') {
                key = key.substring(1);
            }
            value = parts[i].split('=')[1];
            if (key && value) {
                data.push({ name: key, value: value });
            } else if (key) {
                // rfc 4733 (DTMF) style stuff
                data.push({ name: '', value: key });
            }
        }
        return data;
    }

    public static parse_icecandidate(line, logger) {
        logger.log('[Strophe.jingle] jingle.sdp.parse_icecandidate ' + line);
        const candidate: any = {};
        const elems = line.split(' ');
        candidate.foundation = elems[0].substring(12);
        candidate.component = elems[1];
        candidate.protocol = elems[2].toLowerCase();
        candidate.priority = elems[3];
        candidate.ip = elems[4];
        candidate.port = elems[5];
        // elems[6] => "typ"
        candidate.type = elems[7];
        candidate.generation = 0; // default value, may be overwritten below
        for (let i = 8; i < elems.length; i += 2) {
            switch (elems[i]) {
                case 'raddr':
                    candidate['rel-addr'] = elems[i + 1];
                    break;
                case 'rport':
                    candidate['rel-port'] = elems[i + 1];
                    break;
                case 'generation':
                    candidate.generation = elems[i + 1];
                    break;
                case 'tcptype':
                    candidate.tcptype = elems[i + 1];
                    break;
                default: // TODO
            }
        }
        candidate.network = '1';
        candidate.id = Math.random().toString(36).substr(2, 10); // not applicable to SDP -- FIXME: should be unique, not just random
        return candidate;
    }

    public static build_icecandidate(cand, logger) {
        let line = ['a=candidate:' + cand.foundation, cand.component, cand.protocol, cand.priority, cand.ip, cand.port, 'typ', cand.type].join(' ');
        line += ' ';
        switch (cand.type) {
            case 'srflx':
            case 'prflx':
            case 'relay':
                if (cand.hasOwnAttribute('rel-addr') && cand.hasOwnAttribute('rel-port')) {
                    line += 'raddr';
                    line += ' ';
                    line += cand['rel-addr'];
                    line += ' ';
                    line += 'rport';
                    line += ' ';
                    line += cand['rel-port'];
                    line += ' ';
                }
                break;
            default:
                break;
        }
        if (cand.hasOwnAttribute('tcptype')) {
            line += 'tcptype';
            line += ' ';
            line += cand.tcptype;
            line += ' ';
        }
        line += 'generation';
        line += ' ';
        line += cand.hasOwnAttribute('generation') ? cand.generation : '0';
        logger.log('[Strophe.jingle] jingle.sdp.build_icecandidate ' + line);
        return line;
    }

    public static parse_ssrc(desc) {
        // proprietary mapping of a=ssrc lines
        // TODO: see "Jingle RTP Source Description" by Juberti and P. Thatcher on google docs
        // and parse according to that
        const lines = desc.split('\r\n');
        const data = {};
        for (let i = 0; i < lines.length; i++) {
            if (lines[i].substring(0, 7) == 'a=ssrc:') {
                const idx = lines[i].indexOf(' ');
                data[lines[i].substr(idx + 1).split(':', 2)[0]] = lines[i].substr(idx + 1).split(':', 2)[1];
            }
        }
        return data;
    }

    public static parse_rtcpfb(line) {
        const parts = line.substr(10).split(' ');
        const data: any = {};
        data.pt = parts.shift();
        data.type = parts.shift();
        data.params = parts;
        return data;
    }

    public static parse_extmap(line) {
        const parts = line.substr(9).split(' ');
        const data: any = {};
        data.value = parts.shift();
        if (data.value.indexOf('/') != -1) {
            data.direction = data.value.substr(data.value.indexOf('/') + 1);
            data.value = data.value.substr(0, data.value.indexOf('/'));
        } else {
            data.direction = 'both';
        }
        data.uri = parts.shift();
        data.params = parts;
        return data;
    }

    public static find_line(haystack: any, needle: any, sessionpart?: any) {
        let lines = haystack.split('\r\n');
        for (let i = 0; i < lines.length; i++) {
            if (lines[i].substring(0, needle.length) == needle) {
                return lines[i];
            }
        }
        if (!sessionpart) {
            return false;
        }
        // search session part
        lines = sessionpart.split('\r\n');
        for (let j = 0; j < lines.length; j++) {
            if (lines[j].substring(0, needle.length) == needle) {
                return lines[j];
            }
        }
        return false;
    }

    public static find_lines(haystack, needle, sessionpart?: any) {
        let lines = haystack.split('\r\n');
        const needles: any = [];
        for (let i = 0; i < lines.length; i++) {
            if (lines[i].substring(0, needle.length) == needle)
                needles.push(lines[i]);
        }
        if (needles.length || !sessionpart) {
            return needles;
        }
        // search session part
        lines = sessionpart.split('\r\n');
        for (let j = 0; j < lines.length; j++) {
            if (lines[j].substring(0, needle.length) == needle) {
                needles.push(lines[j]);
            }
        }
        return needles;
    }

    public static candidateToJingle(line, logger) {
        let originalLine = line;
        if (line.indexOf('candidate:') === 0) {
            line = 'a=' + line;
        } else if (line.substring(0, 12) != 'a=candidate:') {
            if (logger) {
                logger.log('[Strophe.jingle] parseCandidate called with a line that is not a candidate line');
                logger.log("[Strophe.jingle] " + line);
            }

            return null;
        }
        if (line.substring(line.length - 2) == '\r\n') // chomp it
            line = line.substring(0, line.length - 2);
        const candidate: any = {};
        const elems = line.split(' ');
        let i;
        if (elems[6] != 'typ') {
            if (logger) {
                logger.log('[Strophe.jingle] did not find typ in the right place');
                logger.log("[Strophe.jingle] " + line);
            }

            return null;
        }
        candidate.foundation = elems[0].substring(12);
        candidate.component = elems[1];
        candidate.protocol = elems[2].toLowerCase();
        candidate.priority = elems[3];
        candidate.ip = elems[4];
        candidate.port = elems[5];
        // elems[6] => "typ"
        candidate.type = elems[7];
        candidate.generation = '0';

        for (i = 8; i < elems.length; i += 2) {
            switch (elems[i]) {
                case 'raddr':
                    candidate['rel-addr'] = elems[i + 1];
                    break;
                case 'rport':
                    candidate['rel-port'] = elems[i + 1];
                    break;
                case 'generation':
                    candidate.generation = elems[i + 1];
                    break;
                case 'tcptype':
                    candidate.tcptype = elems[i + 1];
                    break;
                case 'network-cost':
                    candidate.cost = elems[i + 1];
                    break;
                case 'network-id':
                    candidate.network = elems[i + 1];
                    break;
                default: // TODO
                    // logger.log('[Strophe.jingle] not translating "' + elems[i] + '" = "' + elems[i + 1] + '"');
                    //do nothing
            }
        }
        // candidate.network = '1';
        candidate.id = Math.random().toString(36).substr(2, 10); // not applicable to SDP -- FIXME: should be unique, not just random

        if (candidate.type === "relay" && originalLine.indexOf(candidate.priority) !== -1) {
            //add the protocol used for the candidate
            const protocol = SDPUtil.getProtocolFromPriority(candidate.priority);
            originalLine = originalLine.replace(candidate.priority, candidate.priority + "|" + protocol);
        }

        //mask IP address
        if (originalLine.indexOf(candidate.ip) !== -1) {
            //replace the last part of the IP with X
            //ip v4
            let relAddr;
            let ip = originalLine.substring(originalLine.indexOf(candidate.ip), originalLine.indexOf(candidate.ip) + candidate.ip.length);

            //hide local address
            ip = ip.replace(/([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)[0-9]{1,3}/, "$1" + "x");
            //in case of ip v6, expand it and then hide values
            ip = this.expandIPv6(ip);
            ip = ip.replace(/(([0-9a-z]{0,4}\:){1,4})([0-9a-z]{1,4}\:?){4}/, "$1" + "x:x:x:x");

            //in case of peer rflx, hide also realy addr
            if (candidate['rel-addr'] && candidate.type !== "relay") {
                relAddr = originalLine.substring(originalLine.indexOf(candidate['rel-addr']), originalLine.indexOf(candidate['rel-addr']) + candidate['rel-addr'].length);
                relAddr = relAddr.replace(/([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)[0-9]{1,3}/, "$1" + "x");

                relAddr = this.expandIPv6(relAddr);
                relAddr = relAddr.replace(/(([0-9a-z]{0,4}\:){1,4})([0-9a-z]{1,4}\:?){4}/, "$1" + "x:x:x:x");
            }

            originalLine = originalLine.replace(candidate.ip, ip);
            if (relAddr) { originalLine = originalLine.replace(candidate['rel-addr'], relAddr); }
        }


        if (logger) {
            logger.log('[Strophe.jingle] !!! jingle.sdp.candidateToJingle ' + originalLine);
        }

        return candidate;
    }

    private static expandIPv6(address) {
        if (address.includes('.')) {
            return address;
        }

        // Split address into parts around "::"
        const parts = address.split("::");

        const head = parts[0] ? parts[0].split(":") : [];
        const tail = parts[1] ? parts[1].split(":") : [];

        // If there's a double colon, fill the missing segments with zeros
        const missingSegments = 8 - (head.length + tail.length);
        const zeros = new Array(missingSegments).fill("0000");

        const fullParts = [...head, ...zeros, ...tail].map(part => part.padStart(4, "0"));

        if (fullParts.length !== 8) {
            return address;
        }

        return fullParts.join(":");
    }

    private static getProtocolFromPriority(priority) {
        let protocolNumber = priority >> 24;

        const useFirefox = ((window as any).adapter.browserDetails.browser === 'firefox'); // replace by a call to AdapterJS or other

        if (useFirefox) {
            // TCP OR TLS (not possible to distinguish)
            if (protocolNumber === 0) {
                protocolNumber = 3;
            }
            // UDP
            if (protocolNumber === 5) {
                protocolNumber = 2;
            }
        }

        switch (protocolNumber) {
            case 0:
                return "tls";
            case 1:
                return "tcp";
            case 2:
                return "udp";
            case 3:
                return "tcp_or_tls";
            default:
                return "unknown";
        }
    }

    public static candidateFromJingle(cand: any, ufrag?: any, pwd?: any) {
        const parts = [
            'a=candidate:' + cand.getAttribute('foundation'),
            cand.getAttribute('component'),
            cand.getAttribute('protocol'),
            cand.getAttribute('priority'),
            cand.getAttribute('ip'),
            cand.getAttribute('port'),
            'typ',
            cand.getAttribute('type')
        ];
        switch (cand.getAttribute('type')) {
            case 'srflx':
            case 'prflx':
            case 'relay':
                if (cand.getAttribute('rel-addr') && cand.getAttribute('rel-port')) {
                    parts.push('raddr');
                    parts.push(cand.getAttribute('rel-addr'));
                    parts.push('rport');
                    parts.push(cand.getAttribute('rel-port'));
                }
                break;
            default:
                break;
        }
        parts.push('generation');
        parts.push(cand.getAttribute('generation') || '0');

        if (cand.getAttribute('network')) {
            parts.push('network-id');
            parts.push(cand.getAttribute('network'));
        }

        if (cand.getAttribute('cost')) {
            parts.push('network-cost');
            parts.push(cand.getAttribute('cost'));
        }

        if (ufrag) {
            parts.push('ufrag');
            parts.push(ufrag);
        }

        if (pwd) {
            parts.push('pwd');
            parts.push(pwd);
        }

        return parts.join(' ') + '\r\n';
    }
}
